module.exports = __webpack_public_path__ + "img/lb12.66b62687.svg";